import { render, staticRenderFns } from "./NuevoNumero.vue?vue&type=template&id=4db77629&"
import script from "./NuevoNumero.vue?vue&type=script&lang=js&"
export * from "./NuevoNumero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports